function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "LinkedIn@1.5x");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "get-started",
  transform: "translate(-908.000000, -188.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-18"
}, React.createElement("path", {
  d: "M912.375,194.25 L912.375,208 L908,208 L908,194.25 L912.375,194.25 Z M918.7225,194.25 L918.7225,196.87875 C919.2675,196.14625 920.92125,194.25 923.52875,194.25 C923.83375,194.25 924.09375,194.28375 924.33125,194.33125 C924.3925,194.34125 924.4525,194.3525 924.5125,194.36625 C924.5625,194.38 924.6075,194.39625 924.655,194.41125 C926.57625,194.9125 928,196.64375 928,198.72125 L928,198.72125 L928,208 L923.52875,208 L923.52875,208 L923.52875,199.25 C922.1025,195.7925 918.7225,200.5 918.7225,200.5 L918.7225,200.5 L918.7225,208 L914.25,208 L914.25,194.25 L918.7225,194.25 Z M910.1875,188 C911.395623,188 912.375,188.979377 912.375,190.1875 C912.375,191.395623 911.395623,192.375 910.1875,192.375 C908.979377,192.375 908,191.395623 908,190.1875 C908,188.979377 908.979377,188 910.1875,188 Z",
  id: "LinkedIn"
}))));

var SvgLinkedinIcon = function SvgLinkedinIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLinkedinIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin-icon.11344420.svg";
export { ForwardRef as ReactComponent };